export const baseUrl = 'https://app.sgm66.com/api/'